const CurrentClass = [
    { label: "11th", value: "11" },
    { label: "12th", value: "12" },
  ];
  
  export default CurrentClass;
  